<template>
  <div
    v-if="message"
    class="fixed top-4 right-4 max-w-sm bg-white border border-gray-200 rounded-lg shadow-lg p-4 z-50"
    :class="{
      'border-green-200 bg-green-50': message.type === 'success',
      'border-red-200 bg-red-50': message.type === 'error',
    }"
  >
    <div class="flex items-center">
      <div
        class="flex-shrink-0"
        :class="{
          'text-green-600': message.type === 'success',
          'text-red-600': message.type === 'error',
        }"
      >
        <CheckCircleIcon v-if="message.type === 'success'" class="w-5 h-5" />
        <XCircleIcon v-else class="w-5 h-5" />
      </div>
      <div class="ml-3">
        <p
          class="text-sm font-medium"
          :class="{
            'text-green-800': message.type === 'success',
            'text-red-800': message.type === 'error',
          }"
        >
          {{ message.text }}
        </p>
      </div>
      <button @click="$emit('close')" class="ml-auto text-gray-400 hover:text-gray-600">
        <XIcon class="w-4 h-4" />
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { CheckCircleIcon, XCircleIcon, XIcon } from 'lucide-vue-next'

interface Message {
  type: 'success' | 'error'
  text: string
}

interface Props {
  message: Message | null
}

defineProps<Props>()
defineEmits<{
  close: []
}>()
</script>
